import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  selectedOrganization: {
    companyId?: string;
    teamId?: string;
    departmentId?: string;
  };
  themeMode: 'light' | 'dark' | 'system';
}

const initialState: UIState = {
  selectedOrganization: {},
  themeMode:
    (typeof localStorage !== 'undefined' &&
      (localStorage.getItem('themeMode') as 'light' | 'dark' | 'system')) ||
    'system',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSelectedOrganization: (
      state,
      action: PayloadAction<UIState['selectedOrganization']>
    ) => {
      state.selectedOrganization = action.payload;
    },
    setThemeMode: (state, action: PayloadAction<'light' | 'dark' | 'system'>) => {
      state.themeMode = action.payload;
      localStorage.setItem('themeMode', action.payload);
    },
  },
});

export const { setSelectedOrganization, setThemeMode } = uiSlice.actions;

export default uiSlice.reducer;